module.exports = __webpack_public_path__ + "pt_PT-header-786379.webp";